import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'

import type { AppState, FeaturesTree, GetterClass } from '../../../models'

import { FeaturesTreeUtils } from '../../../utils'

import { CONFIG_CONSTS } from '../../config/config.consts'

export class FeaturesTreeGetter implements GetterClass {
  static execute(
    this: void,
    state: AppState,
    getters: any,
    rootState: any,
    rootGetters: any,
  ): FeaturesTree {
    const instanceConfig: Instance =
      rootGetters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`]

    if (!instanceConfig) {
      return {}
    }

    return FeaturesTreeUtils.getFeaturesTree(instanceConfig)
  }
}
